
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Visibility, VisibilityOff } from '@material-ui/icons'
import Button from '@material-ui/core/Button'
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, FormHelperText } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import * as loginActions from './loginActions'
import md5 from '../../libs/crypto-md5/md5'

import './Login.scss'

const Login = ({
  account,
  texts,
  accountNameError,
  passwordError,
  showPassword,
  setShowPassword,
  changeLogin,
  changePasswond,
  login,
  history,
}) => {
  useEffect(() => {
    if (account.accountName && account.passwordMD5) {
      login({ accountName: account.accountName, password: '', passwordMD5: account.passwordMD5, history })
    }
  });
  const [accountNameValue, setAccountName] = useState(account.accountName || '')
  const [passwordValue, setPassword] = useState(account.password || '')

  function handleChangeLogin(event) {
    setAccountName(event.target.value)
  }

  function handleChangePassword(event) {
    setPassword(event.target.value)
  }

  function handleClickShowPassword() {
    setShowPassword(!showPassword)
  }

  function handleMouseDownPassword(event) {
    event.preventDefault()
  }

  function onSubmit() {
    login({ accountName: accountNameValue, password: passwordValue, passwordMD5: md5(passwordValue), history })
  }

  return (
    <Container className="login" maxWidth="xs">
      <form>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={`${texts['placeholder-accountName']}`}
                  name="accountName"
                  variant="outlined"
                  value={accountNameValue}
                  autoComplete="on"
                  error={!!accountNameError}
                  helperText={accountNameError}
                  onChange={handleChangeLogin}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined" error={!!passwordError}>
                  <InputLabel htmlFor="outlined-adornment-password">{`${texts['placeholder-password']}`}</InputLabel>
                  <OutlinedInput
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={passwordValue}
                    autoComplete="on"
                    onChange={handleChangePassword}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label={`${texts['placeholder-password']}`}
                  />
                  <FormHelperText>{passwordError}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Button
              disabled={!accountNameValue || !passwordValue}
              color="secondary"
              fullWidth
              type="submit"
              variant="contained"
              onClick={onSubmit}
            >
              {texts['login-btn']}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  )
}

Login.propTypes = {
  account: PropTypes.object.isRequired,
  texts: PropTypes.object.isRequired,
  accountNameError: PropTypes.string.isRequired,
  passwordError: PropTypes.string.isRequired,
  showPassword: PropTypes.bool.isRequired,
  setShowPassword: PropTypes.func.isRequired,
  changeLogin: PropTypes.func.isRequired,
  changePasswond: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    account: state.app.account,
    texts: state.app.texts,
    showPassword: state.login.showPassword,
    accountNameError: state.login.accountNameError,
    passwordError: state.login.passwordError,
  }), dispatch => bindActionCreators({
    setShowPassword: loginActions.setShowPassword,
    changeLogin: loginActions.changeLogin,
    changePasswond: loginActions.changePasswond,
    login: loginActions.login,
  }, dispatch),
)(Login);
